import { render } from "./PurchaseFileItem.vue?vue&type=template&id=23fada09&scoped=true"
import script from "./PurchaseFileItem.vue?vue&type=script&lang=js"
export * from "./PurchaseFileItem.vue?vue&type=script&lang=js"

import "./PurchaseFileItem.vue?vue&type=style&index=0&id=23fada09&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fada09"]])

export default __exports__